<script lang="ts">
  import { onMount } from 'svelte';
  import Router from 'svelte-spa-router';
  import { isLoading, _ } from 'svelte-i18n';
  import routes from './router';
  import Nav from './components/Nav.svelte';
  import "./theme.scss";
  import { settingsStore, refreshSettings } from './stores/settings';

  import { location } from 'svelte-spa-router';
  // Theme state
  let lightMode = localStorage.getItem('theme') === 'light' || false;
  
  function toggleTheme() {
    lightMode = !lightMode;
    updateTheme();
  }
  
  function updateTheme() {
    if (lightMode) {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    } else {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    }
  }
  
  onMount(() => {
    // Initialize theme
    updateTheme();

    // Load settings
    refreshSettings();
    
  });


</script>

<svelte:head>
  <script type="module" src="https://cdn.jsdelivr.net/npm/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"></script>
  <script nomodule src="https://cdn.jsdelivr.net/npm/ionicons@7.1.0/dist/ionicons/ionicons.js"></script>
</svelte:head>

<!-- Main container -->
<div class="container">
  <!-- Header/Navigation -->
  {#if $isLoading}
    <div class="loading">Loading...</div>
  {:else}
    <Nav darkMode={!lightMode} {toggleTheme} user={$settingsStore.user}/>
  {/if}

  <!-- Main content -->
  <main>
    {#if $isLoading}
      <p>Loading...</p>
    {:else}
      <Router {routes} />
    {/if}
  </main>
  
  <!-- Toast container for notifications -->
  <div id="toast-container"></div>
</div>

<style>

  main {
    padding-top: 0rem;
    padding-bottom: 3rem;
    max-width: 768px;
    margin: 0 auto;
  }


</style> 